/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */
import { IStackStyles } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';
import { ITextStyles } from '@fluentui/react/lib/Text';
import { FontSizes } from '../../../../../../../styles/teams';

export const getTextStyles = (theme: ITheme): ITextStyles => {
    return {
        root: {
            marginTop: '0.75rem',
            marginBottom: '0.5rem',
            lineHeight: '1.25rem',
            color: theme.palette.black,
        },
    };
};

export const getStackStyles = (): IStackStyles => {
    return {
        root: {
            '.fallback-policy-approver-picker': {
                '& div:not(.error-label)>.ms-Label:not(.inner-error-label)': {
                    fontSize: FontSizes.size14,
                    fontWeight: 'normal',
                },
                '& .approvers-people-picker': {
                    marginTop: 0,
                },
            },
        },
    };
};
